import Sales from '../../../services/sales'
import toll from '../../../services/toll'
import {phone} from '../../../filters/string'
import * as Utils from "../../../utils"
import C from '../../common/constantes'

export default {
  props:['vehicles', 'address', 'user', 'payment', 'type', 'planId', 'showRecharge', 'minValue', 'contract', 'newVehicleTax', 'replaceTax'],
  data() {
    return {
      rechargeValueTotal: 0,
      rechargeTaxTotal: 0,
      total: 0,
      terms: false,
      cupom: "",
      descontoCupom: 0,
      erroCupom: undefined,
      loading: undefined,
      totalSemDesconto: 0,
      loading: undefined,
      cupomApplied: false,
      whereToDelivrey:0,
      entries:[],
      showEntries:false,
    }
  },

  computed:{
    cel(){
      let t = this.user.telephones.telephone[1];
      if(t)
        return phone(t.ddd + t.numberPhone);
      return "";
    },
    tel(){
      let t = this.user.telephones.telephone[0];
      if(t)
        return phone(t.ddd + t.numberPhone);
      return "";
    },
    isPF(){
      return this.user.type == 'PESSOA_FISICA';
    },

    image(){
      if(!this.payment)
        return "";
      return '/static/payment-methods/' + this.payment.imagePath.split('.')[0] + '.svg';
    },
    isCaminhoParana(){
      return Utils.isCaminhoParana(this.planId);
    },

    plan(){
      return this.$store.getters.getPlanById(this.planId);
    },
    newAdhesionTax(){
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    guaranteeTax(){
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    linkRntrcTax(){
      return this.$store.getters.getLinkRntrcTax(this.planId);
    },
    monthlyTax(){
      return this.$store.getters.getMonthlyTax(this.planId);
    },


  },

  mounted() {
    let vm = this;
    if(this.showRecharge){
      let recRecharge = {
        planId: this.planId,
        value: this.contract.rechargeValue
      };

      this.loading = Sales.calculateRechargeRate(recRecharge).then(r => {
        this.rechargeValueTotal = r.valueTotal;
        this.rechargeTaxTotal = r.taxTotal;
        this.calculateTotal();
      });
    } else {
      this.calculateTotal();
    }
    this.$store.dispatch('actWhereToDelivrey',0);
  },

  watch: {
    whereToDelivrey: function (newQuestion, oldQuestion) {
      this.$store.dispatch('actWhereToDelivrey',newQuestion);
    }
  },

  methods:{
    calculateTotal(){
      if(this.type == 'replaceTag'){
        this.totalSemDesconto = this.total = this.replaceTax;
      } else {
        this.totalSemDesconto = this.vehicles.length * this.newVehicleTax + this.vehicles.length * this.guaranteeTax + this.rechargeValueTotal + this.rechargeTaxTotal;
        if(this.monthlyTax){
          this.totalSemDesconto += this.vehicles.length * this.monthlyTax;
        }

        if(this.planId == 2 || this.planId == 3){
          this.totalSemDesconto += this.vehicles.length * this.linkRntrcTax;
        }
        this.total = this.totalSemDesconto;

      }
      if(this.isCaminhoParana){
        this.total -= (this.vehicles.length * this.newVehicleTax);
      } else if(this.descontoCupom){
        this.total -= this.descontoCupom;
      }

      this.$emit('setTotal', this.totalSemDesconto);

    },
    validateAll(){
      return this.$validator.validateAll().then(r => {
        return !changeAddress;
      });
    },
    calculateDiscount(){
      this.erroCupom = undefined;
      let req = {
        planId: this.planId,
        promotionCode: this.cupom,
        salesType: 'ADHESIONVEHICLEADDITIONAL'
      };
      Sales.calculateDiscount(req).then(res => {
        
        if(res.productId == C.SALES_TYPE.ADHESIONVEHICLEADDITIONAL || res.productId == C.SALES_TYPE.GUARANTEE){
          let qtd = res.discountLimit == 0 ? this.vehicles.length : Math.min(this.vehicles.length, res.discountLimit);
          this.descontoCupom = qtd * res.valueUnitDiscount;
        } else {
          this.descontoCupom = res.valueUnitDiscount;
        }
        this.cupomApplied = true;
        this.$emit('changePromotionCode', this.cupom);
        this.calculateTotal();

      }).catch(res => {
        
        this.cupomApplied = false;
        this.$emit('changePromotionCode', undefined);
        this.erroCupom = res.data.status.message;
      });
    },

    removeDiscount(){
      this.descontoCupom = 0;
      this.cupomApplied = false;
      this.$emit('changePromotionCode', undefined);
      this.calculateTotal();
    },
    getTolls(state, associateId){
      this.loading = toll.getTollsByState(state)
        .then(res => {
            this.entries = _.filter(res, (o) => {
              return o.associateId == associateId;
            });
            this.showEntries = true;
        })
        .catch(err => {
          
        });

    }


  }
}



// WEBPACK FOOTER //
// ./src/pages/account/vehicle/summary-vehicle.js